import React from "react";
import { useField } from 'formik';
import "../styles.css";
import ErrorField from "./ErrorField";

const NumberInput = ({ label, ...props }) => {
    const [field, meta] = useField(props);

    return (
        <>
            <label htmlFor={props.id || props.name}>{label}</label>
            <input className="text-input" {...field} {...props} onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                }
            }}
            />
            <ErrorField meta={meta}></ErrorField>
        </>
    );
};

export default NumberInput;